import Cookies from 'js-cookie';
import { config } from '@/lib/config'


export async function getRemoveUserCookies() {
    Cookies.remove(`${config.cookietoken}`);
}